<template>
    <div>
        <v-dialog
            v-model="visible"
            fullscreen
            hide-overlay
            scrollable
        >
            <v-card>
                <v-toolbar flat dark style="height: 80px;">
                    <v-chip
                        v-if="checkPermission('zapercomandas_pedido_visualizar_total')"
                        class="ma-1"
                        small
                        outlined
                    >
                        <b>{{ moeda() }}{{ formatPrice(value.total) }}</b>
                    </v-chip>
                    <v-spacer/>
                    <v-toolbar-title>
                        {{ value.id === 'auto' ? 'NOVO PEDIDO' : `PEDIDO ${value.id}`}}
                    </v-toolbar-title>
                    <v-chip
                        v-if="value.id !== 'auto'"
                        :color="origemInfo(value).color"
                        class="ml-3"
                        small
                        dark
                    >
                        <v-icon x-small left>{{ origemInfo(value).icone }}</v-icon>
                        {{ origemInfo(value).label }}
                    </v-chip>
                    <v-spacer/>
                    <v-btn icon dark @click="$emit('close')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <div style="position: absolute; top: 45px;">
                        <v-chip
                            :disabled="isFinalizado"
                            class="ma-1"
                            small
                            outlined
                            @click="abrirObservacao(null, value.observacao)"
                        >
                            <v-icon>mdi-comment-edit-outline</v-icon>
                            <label style="margin-left: 5px;">
                                Obs.: {{ (value.observacao || '').substr(0, 35) }}
                            </label>
                        </v-chip>
                    </div>
                    <div v-if="value.id != 'auto'" style="position: absolute; top: 40px; right: 15px;">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-if="!isFinalizado" @click="pronto">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">
                                                mdi-thumb-{{ value.pronto ? 'down' : 'up' }}
                                            </v-icon>
                                            <span>
                                                {{ `Sinalizar como ${value.pronto ? 'pendente' : 'pronto'}` }}
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="showConfirmado"
                                    @click="updateStatus('confirmado')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-eye-check</v-icon>
                                            <span>Confirmado</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="showEmPreparacao"
                                    @click="updateStatus('em_preparacao')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-chef-hat</v-icon>
                                            <span>Em Preparação</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="showSaiuParaEntrega"
                                    @click="updateStatus('saiu_para_entrega')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-moped</v-icon>
                                            <span>Saiu p/ Entrega</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="showProntoEntregador"
                                    @click="updateStatus('aguardando_retirada')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-moped</v-icon>
                                            <span>Pronto p/ retirada (entregador)</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="showAguardandoRetirada"
                                    @click="updateStatus('aguardando_retirada')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-package-variant-closed-check</v-icon>
                                            <span>Aguardando Retirada</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="showConcluido"
                                    @click="updateStatus('concluido')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-checkbox-marked-circle-outline</v-icon>
                                            <span>Concluído</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="showCancelar"
                                    @click="updateStatus('cancelado')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-close</v-icon>
                                            <span>Cancelar</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="value.id != 'auto'" @click="imprimir()">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-printer</v-icon>
                                            <span>Imprimir Pedido</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="value.id != 'auto' && isDesktopPrintService" @click="imprimirConta()">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-cash-register</v-icon>
                                            <span>Imprimir Conta (Caixa)</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="hasFiscalModule && value.nota_id && isNotaAprovada(value.nota)"
                                    @click="imprimirNotaSaida"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-printer</v-icon>
                                            <span>
                                                Imprimir Nota
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="hasFiscalModule && !isNotaAprovada(value.nota) && checkPermission('zapercomandas_pedido_emitir_nota')"
                                    @click="emitirNotaSaida('nfce')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-note</v-icon>
                                            <span>
                                                Emitir NFC-e
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                    v-if="hasFiscalModule && !isNotaAprovada(value.nota) && checkPermission('zapercomandas_pedido_emitir_nota')"
                                    @click="emitirNotaSaida('nfe')"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
                                            <span>
                                                Emitir NF-e
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </v-toolbar>

                <v-alert
                    v-if="desatualizado"
                    class="mb-0"
                    type="warning"
                    dense
                    tile
                    prominent
                >
                    <div class="d-flex align-center flex-wrap" style="gap: 8px;">
                        <span>
                            Este pedido mudou em outro dispositivo. Atualizar descarta o que você alterou aqui.
                        </span>
                        <v-spacer/>
                        <v-btn small outlined @click="$emit('recarregar')">
                            Atualizar
                        </v-btn>
                    </div>
                </v-alert>

                <v-card-text style="height: 80%;">
                    <div style="overflow-x: auto; white-space: nowrap; padding-top: 10px;">
                        <div style="display: flex;">
                            <CustomerSearchAutocomplete
                                ref="cliente"
                                v-model="value.cliente"
                                :pedido-endereco="value.endereco"
                                @update="onClienteUpdate"
                                @reset="value.cliente = null"
                                style="margin-top: -16px;"
                            />
                            <v-text-field
                                v-if="localizadorIfood"
                                :value="localizadorIfood.codigo"
                                :suffix="localizadorIfood.expirado ? 'expirado' : ''"
                                :class="['mx-2', { 'localizador-expirado': localizadorIfood.expirado }]"
                                label="Localizador iFood"
                                prepend-inner-icon="mdi-phone"
                                readonly
                                outlined
                                dense
                                hide-details
                                style="min-width: 190px; max-width: 220px;"
                            />
                            <v-select
                                :readonly="isFinalizado"
                                hide-details
                                :items="mesas"
                                class="mx-2"
                                outlined
                                dense
                                label="Mesa"
                                v-model="value.mesa"
                                style="min-width: 80px;"
                            />
                            <v-select
                                :readonly="isFinalizado"
                                hide-details
                                :items="pessoas"
                                class="mx-2"
                                outlined
                                dense
                                label="Pessoas"
                                v-model="value.pessoas"
                                style="min-width: 100px;"
                            />
                            <v-select
                                :readonly="isFinalizado"
                                hide-details
                                :items="formasEntrega"
                                class="mx-2 entrega-select"
                                outlined
                                dense
                                label="Entrega"
                                v-model="value.entrega"
                                @change="onChangeEntrega"
                                item-value="id"
                                item-text="descricao"
                                style="min-width: 150px;"
                            >
                                <template v-slot:selection="{ item }">
                                    <span style="display: inline-flex; align-items: center; white-space: nowrap; line-height: 1;">
                                        <span class="entrega-dot" :style="{ backgroundColor: getEntregaCor(item.id) }"></span>
                                        {{ item.descricao }}
                                    </span>
                                </template>
                                <template v-slot:item="{ item }">
                                    <span style="display: inline-flex; align-items: center; white-space: nowrap; line-height: 1;">
                                        <span class="entrega-dot" :style="{ backgroundColor: getEntregaCor(item.id) }"></span>
                                        {{ item.descricao }}
                                    </span>
                                </template>
                            </v-select>
                            <v-select
                                v-if="value.entrega == 2"
                                :readonly="isFinalizado"
                                hide-details
                                :items="entregadores"
                                class="mx-2"
                                outlined
                                dense
                                label="Entregador"
                                v-model="value.entregador_id"
                                item-value="id"
                                item-text="nome"
                                style="min-width: 150px;"
                            />
                            <v-select
                                v-if="value.entrega == 2 && enderecosCliente.length > 1"
                                :readonly="isFinalizado"
                                hide-details
                                :items="enderecosCliente"
                                class="mx-2"
                                outlined
                                dense
                                label="Endereço de entrega"
                                v-model="value.cliente_endereco_id"
                                item-value="id"
                                :item-text="enderecoLabel"
                                @change="onSelectEndereco"
                                style="min-width: 220px;"
                            />
                            <v-select
                                :readonly="isFinalizado"
                                hide-details
                                :items="etiquetas"
                                multiple
                                item-text="nome"
                                item-value="id"
                                class="mx-2"
                                outlined
                                dense
                                label="Etiquetas"
                                v-model="value.etiqueta_ids"
                                style="min-width: 100px;"
                            />
                        </div>
                    </div>
                    <v-data-table
                        fixed-header
                        class="elevation-0"
                        :headers="headers"
                        :items="value.produtos"
                        :mobileBreakpoint="0"
                        :disable-pagination="true"
                        :hide-default-footer="true"
                        :height="$vuetify.breakpoint.height - 275"
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td style="padding-bottom: 10px;">
                                    <v-icon v-if="item.premio">mdi-gift-outline</v-icon>
                                    {{ item.descricao }}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip
                                                v-if="item.created_at"
                                                v-bind="attrs"
                                                v-on="on"
                                                x-small
                                                color="grey lighten-2"
                                                class="ml-2"
                                                style="font-size: 11px;"
                                            >
                                                <v-icon left small color="grey darken-1">mdi-clock-outline</v-icon>
                                                {{ formatInstante(item.created_at, 'HH:mm') }}
                                            </v-chip>
                                        </template>
                                        <span>
                                            {{ `Adicionado em ${formatInstante(item.created_at, 'DD/MM/YYYY HH:mm')}` }}
                                        </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip
                                                v-if="item.kds_user_id"
                                                v-bind="attrs"
                                                v-on="on"
                                                x-small
                                                color="grey lighten-2"
                                                class="ml-2"
                                                style="font-size: 11px;"
                                            >
                                                <v-icon left small color="grey darken-1">mdi-chef-hat</v-icon>
                                                {{ getUserName(item.kds_user_id)  }}
                                            </v-chip>
                                        </template>
                                        <span>
                                            {{ `Usuário responsável: ${getUserName(item.kds_user_id)}` }}
                                        </span>
                                    </v-tooltip>
                                    <i style="color: red;">{{(item.observacao || '').substr(0, 48)}}</i><br>
                                    <div style="display: flex;">
                                        <v-btn
                                            :disabled="isFinalizado"
                                            small
                                            icon
                                            color="black"
                                            @click.stop="comandaRemoverQtd(item.index)"
                                        >
                                            <v-icon large>mdi-minus-box</v-icon>
                                        </v-btn>
                                        <span class="product-qtd">
                                            {{item.quantidade}}
                                        </span>
                                        <v-btn
                                            :disabled="isFinalizado"
                                            small
                                            icon
                                            color="black"
                                            @click.stop="comandaAdicionarQtd(item.index)"
                                        >
                                            <v-icon large>mdi-plus-box</v-icon>
                                        </v-btn>
                                    </div>
                                </td>
                                <td style="text-align: center; min-width: 100px;">
                                    <template v-if="!item.editarValor">
                                        <span>{{ moeda() }}</span>
                                        <span>{{ formatPrice(+item.valor || 0) }}</span>
                                        <!-- Não é possivel editar valor de combo pois ocorre erro na emissão de nota -->
                                        <!-- Quando combo, o valor editavel deveria ser por item do combo -->
                                        <v-icon
                                            v-if="!item.hasOwnProperty('produtos')"
                                            @click="editItemValue(item)"
                                            small
                                        >mdi-pencil</v-icon>
                                    </template>
                                    <template v-else>
                                        <span style="margin-right: -20px;">{{ moeda() }}</span>
                                        <input
                                            @change="atualizarTotais"
                                            type="text"
                                            v-model="item.valor"
                                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                                            style="width: 68px; border: solid 1px #585858; border-radius: 4px; padding-left: 20px;"
                                        >
                                    </template>
                                    <br>
                                    <v-btn
                                        :disabled="isFinalizado"
                                        outlined
                                        small
                                        depressed
                                        color="primary"
                                        @click.stop="abrirObservacao(item, item.observacao)"
                                    >
                                        Obs
                                    </v-btn>
                                </td>
                                <td style="text-align: center;">
                                    <span :style="item.premio ? 'text-decoration: line-through;' : ''">
                                        <b>{{ moeda() }}{{ formatPrice(item.total) }}</b>
                                    </span>
                                    <br>
                                    <v-btn
                                        v-if="item.passos?.length || item.produtos?.length"
                                        outlined
                                        small
                                        depressed
                                        color="primary"
                                        @click.stop="toggleExpand(item)"
                                    >
                                        <v-icon>
                                            {{ expandedItem === item.index ? 'mdi-chevron-up' : 'mdi-format-list-bulleted' }}
                                        </v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <tr v-if="expandedItem === item.index">
                                <td colspan="3" style="background-color: #f9f9f9; padding: 15px 25px;">
                                    <v-expand-transition>
                                        <div>
                                            <!-- Etapas do produto -->
                                            <div v-if="item.passos?.length">
                                                <div v-for="(passo, i) in item.passos" :key="i" class="ml-4 mt-1">
                                                    <div class="font-weight-medium">
                                                        {{ passo.descricao }}
                                                    </div>

                                                    <!-- Complementos de cada etapa -->
                                                    <div v-if="passo.complementos?.length" class="ml-3">
                                                        <ul style="margin: 2px 0 8px 15px;">
                                                            <li
                                                                v-for="(comp, j) in passo.complementos"
                                                                :key="j"
                                                                class="caption grey--text text--darken-1"
                                                            >
                                                                <b v-if="getFracao(passo, comp)">{{ getFracao(passo, comp) }}</b>
                                                                {{ comp.descricao }}
                                                                <b v-if="comp.valor"> — {{ moeda() }} {{ formatPrice(comp.valor) }}</b>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Combo -->
                                            <div v-if="item.produtos?.length">
                                                <div v-for="(p, j) in item.produtos" :key="j" class="ml-4 mb-2">
                                                    <div class="font-weight-medium">{{ p.descricao }}</div>

                                                    <!-- Etapas dentro do combo -->
                                                    <div v-if="p.passos?.length" class="ml-3 mt-1">
                                                        <div v-for="(ps, k) in p.passos" :key="k" class="ml-2">
                                                            <div class="caption">{{ ps.descricao }}</div>

                                                            <!-- Complementos da etapa do combo -->
                                                            <ul v-if="ps.complementos?.length" class="ml-3">
                                                                <li
                                                                    v-for="(c, z) in ps.complementos"
                                                                    :key="z"
                                                                    class="caption grey--text text--darken-1"
                                                                >
                                                                    <b v-if="getFracao(ps, c)">{{ getFracao(ps, c) }}</b>
                                                                    {{ c.descricao }}
                                                                    <b v-if="c.valor"> — {{ moeda() }}{{ formatPrice(c.valor) }}</b>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Observação geral -->
                                            <div v-if="item.observacao" class="mt-3">
                                                <v-divider class="my-2" />
                                                <v-icon x-small color="grey darken-1">mdi-comment-text-outline</v-icon>
                                                <span class="ml-1">{{ item.observacao }}</span>
                                            </div>
                                        </div>
                                    </v-expand-transition>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions style="display: flex; justify-content: space-between; width: 100%;">
                    <v-btn
                        v-if="showPagamento"
                        :disabled="isFinalizado || notaEmitida"
                        color="info"
                        @click="checkoutComanda()"
                        style="width: 32%"
                    >
                        PAGAMENTO
                    </v-btn>

                    <v-btn
                        color="indigo"
                        class="white--text"
                        @click="abrirComandaDetalhes()"
                        style="width: 32%"
                    >
                        DETALHES
                    </v-btn>

                    <v-btn
                        :disabled="isFinalizado || notaEmitida"
                        color="success"
                        @click="onClickSalvar()"
                        :style="showPagamento ? 'width: 32%' : 'width: 65%'"
                    >
                        <v-icon>mdi-content-save</v-icon>
                        SALVAR
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :disabled="isFinalizado || notaEmitida"
                        @click="dialogProdutos = true"
                        fab
                        fixed
                        right
                        bottom
                        x-large
                        color="primary"
                        style="margin-bottom: 50px;"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>mdi-food-fork-drink</v-icon>
                    </v-btn>
                </template>
                <span>Adicionar produtos</span>
            </v-tooltip>
        </v-dialog>

        <v-dialog
            v-model="dialogProdutos"
            fullscreen
            hide-overlay
            scrollable
        >
            <v-card tile>
                <v-toolbar :disabled="isFinalizado" flat dark>
                    <v-btn icon dark @click="onPesquisaProdutoClick()">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-spacer/>
                    <v-toolbar-title>Adicionar Produtos</v-toolbar-title>
                    <v-spacer/>
                    <v-btn icon dark @click="dialogProdutos = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-text-field
                    v-model="pesquisaProduto.value"
                    ref="pesquisaProduto"
                    dense
                    outlined
                    clearable
                    hide-details
                    color="black"
                    label="Pesquise o produto"
                    :style="'position: absolute; top: 10px; left: 70px; background-color: #e9e9e9; z-index: 99;'
                        + (pesquisaProduto.hidden ? 'display: none;' : '')"
                />
                <v-card-text style="height: 80%;">
                    <div style="display: flex; width: 95%; position: fixed; top: 70px; left: 10px; z-index: 99;"
                        @click="onPesquisaProdutoClick('hide')">
                        <v-icon>mdi-chevron-left</v-icon>
                        <div style="overflow-x: auto; white-space: nowrap;">
                            <v-btn
                                v-for="grupo in produtosGrupos" :key="grupo.descricao"
                                color="white"
                                large
                                @click="filtroByGrupo = grupo.descricao"
                            >
                                {{ grupo.descricao }}
                            </v-btn>
                        </div>
                        <v-icon>mdi-chevron-right</v-icon>
                    </div>

                    <v-data-table
                        hide-default-header
                        fixed-header
                        :headers="headersProdutos"
                        :mobileBreakpoint="0"
                        :items="getProdutos()"
                        :hide-default-footer="true"
                        :disable-pagination="true"
                        style="margin-top: 60px;"
                        sort-by="descricao"
                        :height="$vuetify.breakpoint.height - 230"
                    >
                        <template v-slot:item="{ item }">
                            <tr @click="produtoAdicionarQtd(item.produto_id, item.grupo.id)">
                                <td style="padding: 0;">
                                    <v-badge
                                        v-if="item.quantidade > 0"
                                        offset-x="0"
                                        offset-y="40"
                                        color="primary"
                                        :content="item.quantidade"
                                        style="z-index: 1;"
                                    />
                                    <v-img
                                        :src="getUrl(item.imagem)"
                                        width="60"
                                        height="60"
                                    />
                                </td>
                                <td>
                                    <div>
                                        {{ item.descricao }}
                                        <v-chip
                                            v-if="isIndisponivel(item)"
                                            class="white--text ml-1"
                                            color="error"
                                            x-small
                                        >
                                            {{ isIndisponivel(item) }}
                                        </v-chip>
                                    </div>
                                </td>
                                <td>
                                    {{ formatPrice(item.valor) }}
                                </td>
                                <td style="padding: 0px;">
                                    <v-btn
                                        :disabled="isFinalizado"
                                        v-if="item.quantidade > 0"
                                        color="error"
                                        x-small
                                        @click.stop="produtoRemoverQtd(item.produto_id)"
                                    >
                                        <v-icon x-small>mdi-minus</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions>
                    <v-chip class="ma-1" label small outlined>
                        <b>SELECIONADO {{ moeda() }} {{ formatPrice(totalSelecionado) }}</b>
                    </v-chip>
                    <v-spacer/>
                    <v-btn
                        @click="comandaAdicionar"
                        color="success"
                        style="width: 190px;"
                    >Adicionar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogObservacao" persistent>
            <v-card>
                <v-card-title class="mb-6">
                    <span>Observação</span>
                    <v-spacer/>
                    <v-btn icon @click="dialogObservacao = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text :style="`height: ${$vuetify.breakpoint.height - 350}px;`">
                    <v-textarea
                        clearable
                        clear-icon="mdi-backspace-outline"
                        v-model="observacao.text"
                        placeholder="Ex: Remover tomate..."
                        outlined
                        height="420"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="dialogObservacao = false"
                        color="warning"
                        text
                    >Cancelar</v-btn>
                    <v-spacer/>
                    <v-btn
                        @click="adicionarObservacao"
                        color="primary"
                        large
                    >
                        <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DialogDetalhes
            v-model="value"
            :visible="dialogDetalhes.visible"
            :item="dialogDetalhes.item"
            @close="onDialogDetalhesClose"
            @editarCliente="$refs.cliente.openDialogCliente()"
        />

        <DialogSteps
            v-model="dialogSteps.item"
            :visible="dialogSteps.visible"
            @finish="onStepsFinish"
            @close="dialogSteps = { visible: false }"
        />

        <ConfirmDatetime ref="confirm" />
    </div>
</template>

<script>
import DialogSteps from './DialogSteps.vue';
import DialogDetalhes from './DialogDetalhes.vue';
import CustomerSearchAutocomplete from './Pedido/CustomerSearchAutocomplete.vue';
import ConfirmDatetime from '@/components/ConfirmDatetime';
import { subtotal, subtotalGeral } from '@/utils/calc';
import { clone, printDanfe } from '@/utils/utils';
import { hasModule } from '@/utils/module';
import { origemInfo, ehDeMarketplace } from '@/utils/origemPedido';
import { mapState } from 'vuex';
import { fracao } from '@/utils/calc';
import { semEstoqueBloqueando } from '@/utils/estoque';

export default {
    name: 'DialogComanda',

    components: {
        DialogSteps,
        DialogDetalhes,
        ConfirmDatetime,
        CustomerSearchAutocomplete,
    },

    props: {
        visible: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
        },

        desatualizado: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        pesquisaProduto: {
            value: '',
            hidden: true,
        },
        filtroProduto: '',
        filtroByGrupo: '',
        totalSelecionado: 0,
        mesas: Array.from({length: 50}, (_, i) => i + 1),
        pessoas: Array.from({length: 25}, (_, i) => i + 1),
        dialogDetalhes: {
            visible: false,
            item: {},
            comanda: {},
        },
        dialogSteps: {
            visible: false,
            item: {},
        },
        dialogProdutos: false,
        dialogObservacao: false,
        observacao: {item: '', text: ''},
        headersProdutos: [
            {text: 'Qtd', value: 'quantidade', sortable: false, align: 'center'},
            {text: 'Item', value: 'descricao', sortable: false, align: 'start'}, // start center end
            {text: 'Valor', value: 'valor', sortable: false, align: 'center'},
            {text: '', value: 'acoes', sortable: false, align: 'center'},
        ],
        headers: [
            {text: 'Item', value: 'item', sortable: false, align: 'start'}, // start center end
            {text: 'Valor', value: 'valor', sortable: false, align: 'center'},
            {text: 'Total', value: 'total', sortable: false, align: 'center'},
        ],
        expandedItem: null,
    }),

    computed: {
        ...mapState([
            'usuario',
            'usuarios',
            'produtos',
            'etiquetas',
            'produtosGrupos',
            'configuracoes',
            'entregadores',
            'formasEntrega',
        ]),

        enderecosCliente() {
            return this.value.cliente?.enderecos || [];
        },

        enderecoSelecionado() {
            const list = this.enderecosCliente;
            if (!list.length) {
                return null;
            }
            // ordenado pelo backend com o padrão primeiro; respeita a seleção do pedido
            return list.find(e => e.id === this.value.cliente_endereco_id) || list[0];
        },

        isDesktopPrintService() {
            return this.configuracoes?.impressao?.servicoImpressao === 'ZaperMenu Multi Impressora Desktop';
        },

        isFinalizado() {
            return this.value.finalizado || ehDeMarketplace(this.value);
        },

        notaEmitida() {
            return this.value.nota_id;
        },

        showConfirmado() {
            return !this.isFinalizado
                && this.value.status === 'aguardando_pagamento'
                && this.checkPermission('zapercomandas_pedido_alterar_status_em_preparacao');
        },

        showEmPreparacao() {
            return !this.isFinalizado
                && this.value.entrega != 3
                && this.value.status === 'confirmado'
                && this.checkPermission('zapercomandas_pedido_alterar_status_em_preparacao');
        },

        // Pedido iFood com logística do iFood: entregador alocado pelo iFood →
        // fluxo é "pronto p/ retirada" (readyToPickup), não "saiu p/ entrega".
        isEntregaIfood() {
            return this.value.origem === 'ifood' && this.value.ifood_delivered_by === 'IFOOD';
        },

        localizadorIfood() {
            const telefone = this.value.ifood_telefone;
            if (!telefone?.localizador) {
                return null;
            }

            const expiraEm = telefone.localizador_expira_em ? new Date(telefone.localizador_expira_em) : null;

            return {
                codigo: String(telefone.localizador).replace(/(\d{4})(?=\d)/g, '$1 '),
                expirado: !!expiraEm && expiraEm.getTime() < Date.now(),
            };
        },

        showSaiuParaEntrega() {
            return !this.isFinalizado
                && this.value.entrega == 2
                && !this.isEntregaIfood
                && ['em_preparacao', 'confirmado'].includes(this.value.status)
                && this.checkPermission('zapercomandas_pedido_alterar_status_saiu_para_entrega');
        },

        showProntoEntregador() {
            return !this.isFinalizado
                && this.isEntregaIfood
                && ['em_preparacao', 'confirmado'].includes(this.value.status)
                && this.checkPermission('zapercomandas_pedido_alterar_status_aguardando_retirada');
        },

        showAguardandoRetirada() {
            return !this.isFinalizado
                && this.value.entrega == 1
                && ['em_preparacao', 'confirmado'].includes(this.value.status)
                && this.checkPermission('zapercomandas_pedido_alterar_status_aguardando_retirada');
        },

        showCancelar() {
            return this.checkPermission('zapercomandas_pedido_cancelar') && this.value.status != 'cancelado';
        },

        showConcluido() {
            return this.checkPermission('zapercomandas_pedido_concluir') && !this.isFinalizado && this.value.status != 'concluido';
        },

        requireSupervisorPassword() {
            return this.checkPermission('zapercomandas_pedido_exigir_senha_supervisao') && this.configuracoes.supervisor_password;
        },

        hasFiscalModule() {
            return hasModule('FISCAL');
        },

        showPagamento() {
            return this.value.id != 'auto' && this.checkPermission('zapercomandas_pedido_pagamento');
        },
    },

    watch: {
        visible(v) {
            this.value.produtos.map(p => (p.editarValor = false));

            !v && this.$emit('close');
        },

        'value.id'(id) {
            id && this.atualizarTotais();
        },
    },

    methods: {
        origemInfo,

        getEntregaCor(id) {
            const cores = {
                1: '#85144b', // Retirar no Balcão
                2: '#0091D5', // Delivery
                3: '#003366', // Mesa
            };
            return cores[id] || '#9e9e9e';
        },

        toggleExpand(item) {
            this.expandedItem = this.expandedItem === item.index ? null : item.index;
        },

        getFracao(passo, complemento) {
            return fracao(passo, complemento, { unico: '' });
        },

        pronto() {
            this.value.pronto = !this.value.pronto;
            this.$forceUpdate();
        },

        async onClickSalvar() {
            const data = await this.save();

            if (data?.hasPendingPrints && this.configuracoes.impressao?.imprimirAlteracoes) {
                // trigger: 'auto' — disparo do "imprimir alterações ao salvar" é automático,
                // não clique manual. Mantém o filtro de diff de PedidoReport ativo.
                this.$emit('imprimir', { pedido: this.value, tipo: 'resumido', trigger: 'auto' });
            }
        },

        async save() {
            // if (this.value.origem != 'tablet' && !this.value.cliente_id) {
            //     this.notify('Informe o cliente', 'warning');
            //     return;
            // }

            // O endereço do pedido é um SNAPSHOT imutável: protegido quando JÁ existe.
            // Derivamos do cliente na CRIAÇÃO, ou quando for delivery e o pedido ainda
            // NÃO tem endereço (ex.: era retirada e virou delivery) e o cliente tem um
            // endereço selecionável. Pedido com snapshot real continua imutável.
            // Obs.: o endereço NÃO é obrigatório — há lojas que trabalham só com
            // localização/coordenadas; não bloqueamos o save por falta de endereço.
            const semSnapshotEndereco = !this.value.endereco || !this.value.endereco.rua;
            if (this.value.id == 'auto' || (this.value.entrega == 2 && semSnapshotEndereco)) {
                this.aplicarEnderecoSnapshot(this.enderecoSelecionado);
            }

            if (this.value.id == 'auto') {
                this.$root.$emit('loading', true);
                return await this.$http.post('pedidos', this.value)
                    .then(resp => {
                        if (resp.data.type == 'warning') {
                            this.notify(resp.data.msg, 'warning');
                            return;
                        }

                        this.notify('Salvo com sucesso!');
                        this.$emit('close');
                    })
                    .catch(() => this.notify('Não foi possivel salvar', 'warning'))
                    .finally(() => this.$root.$emit('loading', false));
            }

            if (this.requireSupervisorPassword) {
                this.value.supervisor_password = prompt('Digite a senha de supervisão');

                if (!this.value.supervisor_password) {
                    return;
                }
            }

            try {
                this.$root.$emit('loading', true);
                const { data } = await this.$http.put(`pedidos/${this.value.id}`, this.value);

                this.$root.$emit('loading', false);

                if (data.type == 'warning') {
                    this.notify(data.msg, 'warning');
                    return;
                }

                if (data.wpp && data.wpp.type === 'warning') {
                    this.notify(data.wpp.msg, 'warning');
                } else {
                    this.notify('Atualizado com sucesso!');
                }

                this.$emit('close');

                return data;
            } catch (e) {
                this.notify('Não foi possivel salvar', 'warning')
                this.$root.$emit('loading', false);
            }
        },

        comandaAdicionarQtd(index) {
            (this.value.produtos.find(produto => produto.index == index)).quantidade++;
            this.atualizarTotais();
        },

        comandaRemoverQtd(index) {
            this.value.produtos = this.value.produtos.filter(produto => {
                if (produto.index == index && produto.quantidade > 0) {
                    produto.quantidade--;
                }

                return produto.quantidade > 0;
            });

            this.atualizarTotais();
        },

        isIndisponivel(produto) {
            if (produto.status == 'inativo') {
                return 'inativo';
            }

            return semEstoqueBloqueando(produto) ? 'sem estoque' : false;
        },

        async produtoAdicionarQtd(produto_id, grupo_id) {
            const produto = this.produtos.find(p => p.produto_id == produto_id && p.grupo.id == grupo_id);

            // const isIndisponivel = this.isIndisponivel(produto);
            // const msg = 'Produto indisponível, deseja adicionar mesmo assim?';
            // if (isIndisponivel && !await this.$root.$confirm('Confirmação', msg, { color: 'red darken-1' })) {
            //     return;
            // }

            let comboWithSteps = false;
            produto.produtos?.forEach(c => (c.passos?.length && (comboWithSteps = true)));
            const hasSteps = produto?.passos?.length || comboWithSteps;

            //TODO: ajustar para conseguir adicionar varios itens com etapas sem precisar adicionar um a um
            // poderia duplicar o item na listagem...
            if (hasSteps && produto.quantidade > 0) {
                this.notify('Item já escolhido, adicione na comanda antes de continuar', 'warning');
                return;
            }

            if (hasSteps) {
                this.dialogSteps = { visible: true, item: produto };
                return;
            }

            produto.quantidade++;

            this.atualizarTotais();
        },

        produtoRemoverQtd(id) {
            this.produtos.forEach(d => {
                if (id == d.produto_id && d.quantidade > 0) {
                    d.quantidade--;
                }
            });
            this.atualizarTotais();
        },

        atualizarTotais() {
            this.value.produtos.map(i => (i.total = subtotal(i)));

            const produtos = subtotalGeral(this.value.produtos);
            const valorFrete = this.value.entrega == 2 ? (+this.value.valor_frete || 0) : 0;
            const total = produtos + valorFrete + (+this.value.acrescimo || 0) - (+this.value.desconto || 0);

            this.value.total = total;

            this.updateTotalSelecionado();
            this.$forceUpdate();
        },

        comandaAdicionar() {
            const adicionar = i => {
                i = clone(i);
                i.passos = i.__passos__;

                i.produtos?.forEach(produto => {
                    produto.produto_id = clone(produto.produto_id || produto.id);
                    produto.id = null;
                });

                i.id = null;

                if (i.hasOwnProperty('produtos')) {
                    i.combo_id = clone(i.combo_id || i.produto_id);
                    i.produto_id = null;
                } else {
                    i.produto_id = clone(i.produto_id || i.produto_id);
                }

                // let comboWithSteps = false;
                if (i?.produtos?.length) {
                    i.produtos.forEach(produto => {
                        produto.passos = produto.__passos__;
                        // produto.passos?.length && (comboWithSteps = true);
                    });
                }

                // const hasSteps = i.passos?.length || comboWithSteps;

                // let match = false;
                // this.value.produtos.forEach(c => {
                //     if (c.produto_id == i.produto_id && c.grupo_id == i.grupo_id && !hasSteps) {
                //         c.quantidade = +c.quantidade + +i.quantidade;
                //         match = true;
                //     }
                // });
                // !match && this.value.produtos.push(i);

                // Adequado para sempre lançar os produtos separadamente pela dialog de produtos
                this.value.produtos.push(i);
            };

            this.produtos.forEach(e => {
                (e.quantidade > 0) && adicionar(e);
                e.quantidade = 0;
            });

            this.atualizarTotais();
            this.dialogProdutos = false;
        },

        abrirObservacao(item, text) {
            this.observacao = { item, text };
            this.dialogObservacao = true;
        },

        abrirComandaDetalhes() {
            this.dialogDetalhes = {
                visible: true,
            };
        },

        abrirProdutoDetalhes(item) {
            this.dialogDetalhes = {
                visible: true,
                item,
            };
        },

        adicionarObservacao() {
            if (!this.observacao.item) {
                this.value.observacao = this.observacao.text;
            } else {
                const produto = this.observacao.item;

                const produtos = this.value.produtos.filter(i => {
                    (produto.index == i.index) && (i.observacao = this.observacao.text);
                    return i;
                });

                this.value.produtos = produtos;
            }
            this.dialogObservacao = false;
        },

        onPesquisaProdutoClick(hide) {
            this.pesquisaProduto.hidden = hide || !this.pesquisaProduto.hidden;

            if (this.pesquisaProduto.hidden) {
                this.pesquisaProduto.value = '';
                return;
            }

            this.$nextTick(() => this.$refs.pesquisaProduto?.focus());
        },

        normalizar(str) {
            return (str || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
        },

        getProdutos() {
            let products = [];
            const search = this.normalizar(this.pesquisaProduto.value);

            if (!search) {
               products = this.filtroByGrupo
                ? this.produtos.filter(produto => produto.grupo.descricao == this.filtroByGrupo)
                : this.produtos;

                products.forEach((produto, index) => {
                    produto.index = index + 1;
                    return produto;
                });

                return products;
            }

            products = this.produtos.filter(produto => this.normalizar(produto.descricao).includes(search));

            products.forEach((produto, index) => {
                produto.index = index + 1;
                return produto;
            });

            return products;
        },

        onStepsFinish({produto_id, grupo, passos, produtos}) {
            this.dialogSteps = { visible: false, item: null };

            const grupo_id = grupo.id;
            const produto = this.produtos.find(p => p.produto_id == produto_id && p.grupo.id == grupo_id);

            // Combo
            if (produtos?.length) {
                produto.produtos.forEach((p, index) => {
                    if (!p.passos?.length) {
                        return;
                    }

                    p.__passos__ = produtos[index].passos;
                })
            }

            produto.__passos__ = passos;
            produto.quantidade++;

            this.atualizarTotais();
        },

        imprimir(tipo = 'completo') {
            const data = {
                pedido: this.value.id,
                tipo,
                entrega: this.value.entrega ?? null,
            };
            this.$root.$emit('imprimir', data);
        },

        imprimirConta() {
            this.$root.$emit('imprimir-conta', this.value.id);
        },

        async checkoutComanda() {
            const data = await this.save();

            if (data?.type === 'success') {
                this.$store.commit('setData', {id: this.value.id});
                this.$router.push('/checkout');
            }
        },

        getUrl(img) {
            if (!img?.url) {
                return require('@/assets/noimageavailable.png');
            }

            const url = img.tmp
                ? `${this.$urlAPI}/files/tmp/${img.url}`
                : `${this.$urlAPI}/storage/${img.url}`;

            return url;
        },

        async updateStatus(status) {
            if (status === 'cancelado') {
                const confirm = await this.$root.$confirm(
                    'Confirmação',
                    'Deseja realmente cancelar?',
                    { color: 'red darken-1' }
                );

                if (!confirm) {
                    return;
                }
            }

            const statusAnterior = this.value.status;
            this.value.status = status;

            const data = await this.save();

            if (data?.type !== 'success') {
                this.value.status = statusAnterior;
            }
        },

        onClienteUpdate(cliente) {
            this.value.cliente = cliente;
            this.value.cliente_id = cliente?.id;

            const enderecos = cliente?.enderecos || [];

            // pedido em edição: preserva o endereço/frete já selecionados
            const jaSelecionado = enderecos.find(e => e.id === this.value.cliente_endereco_id);
            if (jaSelecionado) {
                return;
            }

            // Pedido EXISTENTE COM snapshot: imutável — nunca re-derivar do cliente ao
            // vivo (mesmo que a FK tenha ficado obsoleta após edição do cadastro).
            // Existente SEM snapshot (ex.: era retirada e virou delivery): pode derivar.
            const semSnapshot = !this.value.endereco || !this.value.endereco.rua;
            if (this.value.id != 'auto' && !semSnapshot) {
                return;
            }

            // novo: assume o endereço padrão (primeiro da lista ordenada)
            const padrao = enderecos[0] || null;

            // Cliente sem endereço cadastrado (ex: pedido iFood, que traz endereço e
            // taxa em snapshot próprio em value.endereco/valor_frete) → preserva o
            // frete e o endereço atuais em vez de zerá-los.
            if (!padrao) {
                return;
            }

            this.value.cliente_endereco_id = padrao.id;
            this.value.valor_frete = padrao.valor_frete || 0;
            this.aplicarEnderecoSnapshot(padrao);
        },

        onChangeEntrega() {
            // ao mudar para Delivery sem endereço, já aplica o endereço padrão/selecionado
            // do cliente (feedback imediato; o save() também garante isso).
            const semSnapshot = !this.value.endereco || !this.value.endereco.rua;
            if (this.value.entrega == 2 && semSnapshot && this.enderecoSelecionado) {
                this.value.cliente_endereco_id = this.value.cliente_endereco_id || this.enderecoSelecionado.id;
                this.value.valor_frete = this.enderecoSelecionado.valor_frete || 0;
                this.aplicarEnderecoSnapshot(this.enderecoSelecionado);
            }
        },

        onSelectEndereco() {
            const endereco = this.enderecoSelecionado;
            // Sem endereço selecionado (ex: pedido iFood, sem endereços de cliente)
            // → preserva o frete/endereço (snapshot) em vez de zerar.
            if (!endereco) {
                return;
            }
            this.value.valor_frete = endereco.valor_frete || 0;
            this.aplicarEnderecoSnapshot(endereco);
        },

        aplicarEnderecoSnapshot(endereco) {
            if (!endereco) {
                return;
            }

            this.value.cliente_endereco_id = endereco.id;
            this.value.endereco = {
                uuid: endereco.uuid,
                uf: endereco.uf,
                cep: endereco.cep,
                rua: endereco.rua,
                bairro: endereco.bairro,
                numero: endereco.numero,
                municipio: endereco.municipio,
                complemento: endereco.referencia,
                coordenadas: endereco.coordenadas,
                tipo_local: endereco.tipo_local,
                descricao: endereco.descricao,
            };

            if (endereco.tipo_local === 'apartamento') {
                this.value.endereco.nome_edificio = endereco.nome_edificio;
                this.value.endereco.numero_apartamento = endereco.numero_apartamento;
            }
        },

        enderecoLabel(endereco) {
            if (!endereco) {
                return '';
            }
            if (endereco.descricao) {
                return endereco.descricao;
            }
            const partes = [endereco.rua, endereco.numero].filter(Boolean).join(', ');
            return partes || endereco.bairro || `Endereço ${endereco.id}`;
        },

        editItemValue(item) {
            const produtos = this.value.produtos.filter(i => {
                i.editarValor = i === item;
                i.editarValor && (i.valor = (+i.valor || 0).toFixed(2));

                return i;
            });

            this.value.produtos = produtos;
        },

        onDialogDetalhesClose() {
            this.dialogDetalhes = { visible: false };
            this.atualizarTotais();
        },

        updateTotalSelecionado() {
            this.totalSelecionado = this.produtos.reduce((a, b) => a + (+b.quantidade * +b.valor || 0), 0);
        },

        imprimirNotaSaida() {
            printDanfe(this.value.nota);
        },

        async emitirNotaSaida(modelo) {
            let dataEmissao = undefined;

            if (modelo === 'nfe') {
                const confirm = await this.$refs.confirm.open(
                    'Emitir NF-e',
                    '',
                    { color: 'success' }
                );

                if (!confirm) {
                    return;
                }

                dataEmissao = confirm.dataEmissao;
            }

            const data = { pedido_id: this.value.id, modelo, data_emissao: dataEmissao };

            this.$root.$emit('loading', true);
            this.$http.post('fiscal/emissao-nota-saida', data)
                .then(resp => {
                    if (resp.data.type == 'warning') {
                        this.notify(resp.data.msg, 'warning');
                        return;
                    }
                    const data = resp.data.data;

                    if (data?.nfe?.status === 'aprovado') {
                        this.notify(`Aprovado, ${data.nfe.motivo}`);
                    } else {
                        this.notify(`${data.nfe.status} ${data.nfe.motivo}`, 'warning');
                    }
                })
                .catch(() => {
                    this.notify('Verifique sua conexão com a internet', 'warning');
                }).finally(() => (this.$root.$emit('loading', false)));
        },

        isNotaAprovada(nota) {
            return nota?.status === 'aprovado';
        },

        getUserName(id) {
            return this.usuarios.find(u => u.id === id)?.name || '';
        },
    },
}
</script>

<style scoped>
.entrega-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
    vertical-align: middle;
}

.localizador-expirado ::v-deep input {
    color: rgba(0, 0, 0, 0.38);
}

/* impede que o input interno do select quebre para a 2ª linha (altura cresceria no foco) */
.entrega-select ::v-deep .v-select__selections {
    flex-wrap: nowrap;
}

.product-qtd {
    width: 20px;
    text-align: center;
    font-weight: bold;
    margin: 2px 5px 0 5px;
    font-size: 16px;
}

.class-on-data-table table {
    table-layout: fixed;
}

.v-card__text, .v-card__title {
    word-break: normal;
    /* maybe !important  */
}

.v-card__title {
    padding: 0 16px 0 16px;
    font-size: 15px;
    height: 35px !important;
}

.v-badge {
    display: inline;
}

.v-list-item {
    min-height: 28px !important;
}

.v-chip {
    font-weight: 500;
}
</style>
